import NIEApplication from "../assets/img/concierge/NIEApplications.jpeg";
import Mortgage from "../assets/img/concierge/Mortgage.jpeg";
import Insurance from "../assets/img/concierge/Insurance.jpeg";
import Utility from "../assets/img/concierge/Utility.jpeg";
import Vehicle from "../assets/img/concierge/Vehicle.jpeg";
import Legal from "../assets/img/concierge/Legal.jpeg";
import Property from "../assets/img/concierge/Property.jpeg";
import Relocation from "../assets/img/concierge/Relocation.jpeg";
import Airport from "../assets/img/concierge/Airport.jpeg";
import School from "../assets/img/concierge/School.jpeg";
import Healthcare from "../assets/img/concierge/Healthcare.jpeg";
import Translation from "../assets/img/concierge/Translation.jpeg";
import Personal from "../assets/img/concierge/Personal.jpeg";
import Business from "../assets/img/concierge/Business.jpeg";
import Concierge from "../assets/img/concierge/Concierge.jpeg";
import VIP from "../assets/img/concierge/VIP.jpeg";


const conciergeServices = [
   {
    title: "Property Maintenance & Management",
    description:
      "Protect and maintain your investment with trusted property management solutions.",
    image:Property,
    slug: "property-maintenance-management",
    link: "/concierge/property-maintenance-management",
    intro:
      "We help owners keep their property well maintained, secure, and ready for guests or future visits.",
    highlights: [
      "Routine maintenance coordination and contractor support",
      "Reliable oversight for holiday homes and investment properties",
      "Flexible management options for owners abroad",
    ],
    steps: [
      "We understand the maintenance and occupancy needs of your property.",
      "We arrange trusted support and regular check-ins.",
      "We keep your property in good condition all year round.",
    ],
    expectations: [
      "An easier way to manage a remote property",
      "Better care for your home and investment",
      "Consistent support with minimal owner effort",
    ],
  },
  {
    title: "NIE Applications",
    description:
      "Helping international clients obtain essential documentation required for living and investing in Spain.",
    image:NIEApplication,
    slug: "nie-applications",
    link: "/concierge/nie-applications",
    intro:
      "We simplify the NIE process so you can focus on your move, investment, or property purchase with less paperwork stress.",
    highlights: [
      "Fast appointment preparation and document review",
      "Step-by-step guidance for first-time applicants",
      "Support for investors, residents, and property buyers",
    ],
    steps: [
      "We review your personal documents and confirm the exact application requirements.",
      "We prepare the application package and guide you through each official step.",
      "We coordinate follow-up support so your paperwork stays on track.",
    ],
    expectations: [
      "Clear advice from the beginning",
      "Reduced delays and missing-document issues",
      "Reliable support throughout the process",
    ],
  },
  {
    title: "Mortgage Assistance",
    description:
      "Expert guidance to help secure the best financing solutions tailored to your property goals.",
    image:Mortgage,
    slug: "mortgage-assistance",
    link: "/concierge/mortgage-assistance",
    intro:
      "We connect you with trusted mortgage experts and simplify the financing journey for your Spanish property.",
    highlights: [
      "Tailored mortgage options for residents and non-residents",
      "Support with lender comparison and documentation",
      "Clear guidance on rates, fees, and repayment terms",
    ],
    steps: [
      "We review your property goals and financing needs.",
      "We recommend suitable lenders and prepare the paperwork trail.",
      "We help you move from approval to completion with confidence.",
    ],
    expectations: [
      "Better clarity around your financing choices",
      "Faster lender communication",
      "Confidence in your property investment decision",
    ],
  },
  {
    title: "Insurance Arrangements",
    description:
      "Access trusted insurance solutions for your property, health, and lifestyle needs.",
    image:Insurance,
    slug: "insurance-arrangements",
    link: "/concierge/insurance-arrangements",
    intro:
      "We help you arrange dependable insurance cover for your home, health, and everyday life in Spain.",
    highlights: [
      "Property, health, and travel coverage options",
      "Assistance with comparative quotes and policy selection",
      "Support that is easy to understand and tailored to your needs",
    ],
    steps: [
      "We discuss your personal and property protection needs.",
      "We compare suitable insurance products and providers.",
      "We help you finalize the policy with minimal hassle.",
    ],
    expectations: [
      "Peace of mind for your place and lifestyle",
      "Transparent insurance guidance",
      "Flexible options that suit your budget",
    ],
  },
  {
    title: "Utility Connections",
    description:
      "Fast and hassle-free setup of water, electricity, internet, and essential services.",
    image:Utility,
    slug: "utility-connections",
    link: "/concierge/utility-connections",
    intro:
      "We help you activate the essential services needed for a smooth arrival or move-in experience.",
    highlights: [
      "Practical help for electricity, water, and internet setup",
      "Clear coordination with local providers",
      "Support for new arrivals and second-home owners",
    ],
    steps: [
      "We identify the services you need and the documents required.",
      "We guide you through provider registration and scheduling.",
      "We follow up until your essentials are fully connected.",
    ],
    expectations: [
      "Less waiting and fewer admin hurdles",
      "A faster setup experience",
      "Reliable support during your transition",
    ],
  },
  {
    title: "Vehicle Registration & Transfers",
    description:
      "Professional support with registration procedures and ownership transfers.",
    image:Vehicle,
    slug: "vehicle-registration-transfers",
    link: "/concierge/vehicle-registration-transfers",
    intro:
      "We assist with the practical steps needed to register or transfer a vehicle in Spain without confusion.",
    highlights: [
      "Support for registration and ownership transfer paperwork",
      "Guidance on local rules and timing",
      "Coordination with the right officials and documents",
    ],
    steps: [
      "We assess the vehicle transfer requirements for your situation.",
      "We prepare the required paperwork and explain the process clearly.",
      "We support you through registration and final confirmation.",
    ],
    expectations: [
      "Reduced uncertainty around legal requirements",
      "Clear communication at each stage",
      "A smoother vehicle transfer process",
    ],
  },
  {
    title: "Legal & Administrative Support",
    description:
      "Reliable legal guidance and administrative assistance for every stage of ownership.",
    image:Legal,
    slug: "legal-administrative-support",
    link: "/concierge/legal-administrative-support",
    intro:
      "We provide trusted administrative support to help you handle important legal and property-related tasks confidently.",
    highlights: [
      "Reliable support for document preparation and submissions",
      "Assistance with property-related admin matters",
      "Practical help to keep your process organized",
    ],
    steps: [
      "We identify the paperwork and legal steps involved.",
      "We organize your documents and explain what matters most.",
      "We help you move forward with clarity and confidence.",
    ],
    expectations: [
      "Better organization and fewer missed deadlines",
      "Professional support for sensitive tasks",
      "A calmer path through paperwork",
    ],
  },
 
  {
    title: "Relocation Assistance",
    description:
      "Helping individuals and families relocate smoothly and settle comfortably in Spain.",
    image:Relocation,
    slug: "relocation-assistance",
    link: "/concierge/relocation-assistance",
    intro:
      "We make the move to Spain easier by organizing the practical details that matter most from day one.",
    highlights: [
      "Support with settling-in arrangements and local coordination",
      "Help for families, professionals, and retirees",
      "A smoother start to life in your new location",
    ],
    steps: [
      "We map out the practical areas you need help with.",
      "We coordinate the essential services and local arrangements.",
      "We remain available as you settle into your new home.",
    ],
    expectations: [
      "A calmer and more organized move",
      "Less stress during arrival and setup",
      "A better first experience in Spain",
    ],
  },
  {
    title: "Airport Transfers & Transportation",
    description:
      "Reliable airport transfers and private transportation services tailored to your needs.",
    image:Airport,
    slug: "airport-transfers-transportation",
    link: "/concierge/airport-transfers-transportation",
    intro:
      "We coordinate dependable transport so you can arrive, travel, and move around with ease.",
    highlights: [
      "Airport pickup and private transfers",
      "Flexible transport for business and leisure travel",
      "Comfortable service for families and groups",
    ],
    steps: [
      "We confirm your arrival or travel schedule.",
      "We arrange the right vehicle and route for your journey.",
      "We ensure safe and smooth transportation from start to finish.",
    ],
    expectations: [
      "Stress-free arrival and onward travel",
      "Reliable transport timing",
      "A professional experience from the airport onward",
    ],
  },
  {
    title: "School & Education Assistance",
    description:
      "Helping families find the right schools and educational opportunities in Spain.",
    image:School,
    slug: "school-education-assistance",
    link: "/concierge/school-education-assistance",
    intro:
      "We support families who want the right educational environment for children and teenagers in Spain.",
    highlights: [
      "Guidance on school options and local education systems",
      "Assistance with family relocation planning",
      "Support that makes education decisions easier",
    ],
    steps: [
      "We learn about your family’s educational priorities.",
      "We recommend suitable school options and local guidance.",
      "We help you prepare for a smooth transition.",
    ],
    expectations: [
      "Better-informed school choices",
      "More confidence in family relocation planning",
      "A calmer start for children and parents",
    ],
  },
  {
    title: "Healthcare Registration & Support",
    description:
      "Guidance and support for healthcare registration and medical services in Spain.",
    image:Healthcare,
    slug: "healthcare-registration-support",
    link: "/concierge/healthcare-registration-support",
    intro:
      "We help you understand the healthcare registration process and access the support you need.",
    highlights: [
      "Practical guidance on healthcare access and registration",
      "Support for residents and new arrivals",
      "Clear advice for navigating public and private options",
    ],
    steps: [
      "We explain the healthcare registration process in simple terms.",
      "We help collect and prepare the right documents.",
      "We guide you to the right support and next steps.",
    ],
    expectations: [
      "Less confusion around healthcare access",
      "More confidence in getting registered",
      "A smoother experience during relocation",
    ],
  },
  {
    title: "Translation & Interpretation Services",
    description:
      "Professional language support to simplify communication and documentation.",
    image:Translation,
    slug: "translation-interpretation-services",
    link: "/concierge/translation-interpretation-services",
    intro:
      "We help bridge language gaps so your conversations, documents, and official matters are easier to manage.",
    highlights: [
      "Professional interpretation for meetings and appointments",
      "Accurate document translation support",
      "Clear communication for everyday and official needs",
    ],
    steps: [
      "We confirm the language support you need.",
      "We arrange accurate translation or interpretation services.",
      "We ensure your communications feel clear and professional.",
    ],
    expectations: [
      "Fewer language barriers",
      "More confidence during important conversations",
      "A smoother experience with documentation and appointments",
    ],
  },
  {
    title: "Personal Assistants & Lifestyle Management",
    description:
      "Exclusive assistance designed to make daily life in Spain effortless.",
    image:Personal,
    slug: "personal-assistants-lifestyle-management",
    link: "/concierge/personal-assistants-lifestyle-management",
    intro:
      "We provide personalized lifestyle support so your day-to-day life feels organized and stress-free.",
    highlights: [
      "Flexible support for errands, appointments, and arrangements",
      "Tailored help that fits your routine and preferences",
      "A more comfortable pace of living in Spain",
    ],
    steps: [
      "We learn about the daily tasks you want support with.",
      "We create a practical approach to simplify your routine.",
      "We keep everything coordinated so you can enjoy more time.",
    ],
    expectations: [
      "Less time spent managing small details",
      "More convenience and comfort",
      "A lifestyle that feels easier to handle",
    ],
  },
  {
    title: "Business Setup Support in Spain",
    description:
      "Professional guidance for establishing and managing your business in Spain.",
    image:Business,
    slug: "business-setup-support-spain",
    link: "/concierge/business-setup-support-spain",
    intro:
      "We help entrepreneurs and investors navigate the early steps of setting up a business in Spain.",
    highlights: [
      "Support for company setup and admin planning",
      "Clear practical guidance for first-time founders",
      "A smoother start to your business journey",
    ],
    steps: [
      "We review your business goals and the steps needed to begin.",
      "We support document preparation and planning for setup.",
      "We help you move forward with confidence and structure.",
    ],
    expectations: [
      "Better direction from the early stages",
      "Fewer surprises in the setup process",
      "A stronger foundation for your business",
    ],
  },
  {
    title: "Concierge Services for Holiday Homeowners",
    description:
      "Tailored services to maintain and manage your holiday property with complete peace of mind.",
    image:Concierge,
    slug: "holiday-homeowners-concierge",
    link: "/concierge/holiday-homeowners-concierge",
    intro:
      "We support holiday homeowners with practical care and coordination that keeps their property ready and welcoming.",
    highlights: [
      "Property check-ins and guest-ready coordination",
      "Support for maintenance and seasonal care",
      "A trusted local partner for owners abroad",
    ],
    steps: [
      "We understand your property usage and care expectations.",
      "We coordinate regular checks and property support.",
      "We keep your home ready for guests or your next visit.",
    ],
    expectations: [
      "More peace of mind for owners away from home",
      "A better guest experience",
      "Consistent support across the year",
    ],
  },
  {
    title: "VIP & Luxury Lifestyle Services",
    description:
      "Premium lifestyle and concierge services created for discerning clients.",
    image:VIP,
    slug: "vip-luxury-lifestyle-services",
    link: "/concierge/vip-luxury-lifestyle-services",
    intro:
      "We create a premium, effortless experience with personal attention and refined support in every detail.",
    highlights: [
      "High-touch lifestyle planning and personal support",
      "Bespoke arrangements for travel, leisure, and hosting",
      "An elevated experience tailored to your expectations",
    ],
    steps: [
      "We listen closely to your preferences and priorities.",
      "We arrange the details with care and discretion.",
      "We deliver a polished experience from start to finish.",
    ],
    expectations: [
      "A more seamless and elevated lifestyle experience",
      "Time saved through personal support",
      "A premium standard of service",
    ],
  },
];

export { conciergeServices };
export default conciergeServices;
